import { ApiClient } from "../../clients/ApiClient";
import { Analytics } from "../../clients/Analytics";

export function search(searchQuery, first, pageSize, isAppend, currentResults) {
    return new Promise((resolve, reject) => {
        let api = new ApiClient();
        let analytics = new Analytics();

        api.searchSubtitles(searchQuery, first, first + parseInt(pageSize, 10) - 1)
            .then((apiResponse) => {
                analytics.trackPage({ url: "/api/subtitle?q=" + searchQuery });
                analytics.trackEvent({ category: "subs", action: "search", label: searchQuery });

                resolve({
                    searchQuery: searchQuery,
                    searchResult: !isAppend ? apiResponse.data : [].concat(currentResults).concat(apiResponse.data),
                    searchResultRange: { last: apiResponse.range.last, length: apiResponse.range.length },
                    searchError: null,
                    disableForm: false,
                });
            })
            .catch((error) => {
                reject({
                    searchResult: null,
                    searchResultRange: { last: 0, length: 0 },
                    searchError: true,
                    disableForm: false,
                });
            });
    });
}

export function clean(isAppend) {
    if (!isAppend) {
        return {
            searchResult: null,
            searchResultRange: { last: 0, length: 0 },
            searchError: null,
            disableForm: true,
        };
    } else {
        return { disableForm: true };
    }
}



// WEBPACK FOOTER //
// ../containers/SearchPage/actions.js